import Sidebar from "@/components/Sidebar";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import FeedbackWidget from "@/components/FeedbackWidget";
import NotificationsBell from "@/components/NotificationsBell";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function DashboardLayout() {
  return (
    <div className="flex min-h-screen bg-zinc-50">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <ImpersonationBanner />
        <div className="fixed top-3 right-4 z-20">
          <NotificationsBell />
        </div>
        <Outlet />
      </main>
      <FeedbackWidget />
      <Toaster position="top-right" richColors />
    </div>
  );
}
